import { render, staticRenderFns } from "./InventoryForm.vue?vue&type=template&id=8fcb6d70&scoped=true&"
import script from "./InventoryForm.vue?vue&type=script&lang=js&"
export * from "./InventoryForm.vue?vue&type=script&lang=js&"
import style0 from "./InventoryForm.vue?vue&type=style&index=0&id=8fcb6d70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcb6d70",
  null
  
)

export default component.exports